import { isAnyArray } from 'is-any-array';
/**
 * This function
 * @param output - undefined or a new array
 * @param length - length of the output array
 * @returns
 */
export function getOutputArray(output, length) {
    if (output !== undefined) {
        if (!isAnyArray(output)) {
            throw new TypeError('output option must be an array if specified');
        }
        if (output.length !== length) {
            throw new TypeError('the output array does not have the correct length');
        }
        return output;
    }
    else {
        return new Float64Array(length);
    }
}
//# sourceMappingURL=getOutputArray.js.map